export default __webpack_public_path__ + "static/cover-cf70d6ca6cf4b4767722a6fef0d31cf6.png";